import React from "react";
import { Slide } from "react-slideshow-image";

import "../App.css";

function Portada(props) {
  return (
    <div className="container_portada">
      <div className="portada_movil">
        <Slide
          infinite={false}
          indicators={true}
          arrows={false}
          autoplay={false}
          transitionDuration={300}
        >
          <div className="each-slide">
            <div>
              <img className="the-img2" src="/img/portada2.jpg" alt=""></img>
            </div>
          </div>
          <div className="each-slide">
            <div>
              <img className="the-img2" src="/img/info1.jpg" alt=""></img>
            </div>
          </div>
          <div className="each-slide">
            <div>
              <img className="the-img2" src="/img/info3.jpg" alt=""></img>
            </div>
          </div>
          <div className="each-slide">
            <div>
              <img className="the-img2" src="/img/info4.jpg" alt=""></img>
            </div>
          </div>
          <div className="each-slide">
            <div>
              <img className="the-img2" src="/img/info5.jpg" alt=""></img>
            </div>
          </div>
          <div className="each-slide">
            <div>
              <img className="the-img2" src="/img/info2.jpg" alt=""></img>
            </div>
          </div>
        </Slide>
      </div>

      <div className="portada_fija">
        <img src={props.img} alt=""></img>
        <div className='a'>
          <p>{props.name_tag}</p>
        </div>
      </div>
    </div>
  );
}

export default Portada;
